import withFeatureFlagProvider from "./ConfigCatProvider";
import withFlagsConsumer from "./withFlagsConsumer";

/**
 * Wraps a widget's root component with both the ConfigCat provider and the flags/configCatClient
 * consumer, in the right order, so call sites only need one wrap.
 * Usage: export default withFeatureFlags(MyWidget);
 * The wrapped component reads a flag via: this.props.flags?.["my-flag-key"]
 */
const withFeatureFlags = function withFeatureFlags(RootComponent) {
    return withFeatureFlagProvider(withFlagsConsumer(RootComponent));
};

export { withFeatureFlagProvider, withFlagsConsumer, withFeatureFlags };
export default withFeatureFlags;
